import Vue from 'vue';
import { keyboard, activity, mapState, mapMutations } from '../store/helpers';
export default Vue.extend({
    data() {
        return {
            allKeys: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890BackspaceCapLockEnterShift1Shift2- =Tab[]\'/` \\:,.;?!"',
            defaultKeyboardSettings: {
                useDarkTheme: false,
                isGhosting: true,
                showOutline: true,
                isHighlighting: true,
                hideNumberRow: true,
                touchAndHold: false,
                keyboardType: 'Keyboard35',
                showKeyboardAtStart: true,
                roofs: false,
                keyCodesToNotHandleNatively: [],
                keyCodesToHandleNatively: []
            }
        };
    },
    computed: Object.assign({}, mapState(keyboard, ['show', 'enabled', 'holdKeyPressed', 'settings'])),
    methods: Object.assign(Object.assign({}, mapMutations(keyboard, [
        'enableKeyboard',
        'disableKeyboard',
        'showKeyboard',
        'hideKeyboard',
        'configureKeyboard'
    ])), { setupKeyboard() {
            const activitySpecificConfig = this.getKeyboardConfig();
            this.finalizeKeyboardConfig(activitySpecificConfig);
        },
        finalizeKeyboardConfig(activityOverrides) {
            // @ts-ignore
            const { characters } = activity.state.data.keyboard || {};
            const keyboardConfig = Object.assign(Object.assign(Object.assign({}, this.defaultKeyboardSettings), { isTouchHold: !!characters, keys: characters === null ? undefined : characters }), activityOverrides);
            this.configureKeyboard(keyboardConfig);
        },
        // Override method in activities to supercede default settings.
        getKeyboardConfig() {
            return this.defaultKeyboardSettings;
        } })
});
